import React from 'react';
import './Contacts.css';
import '../icons/icons.css';

class Contacts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: 'metr.2017.rail.com@gmail.com',
      phone: '+380975880470',
      address: 'Khortitsa 58'
    }
  }
  render() {
    return (
      <div className="Contacts">
        <h3>Контакты по которым вы можете связаться с разработчиком данного творения</h3>
        <div className="contacts__item">
          <ul>
            <li className="email">em@il Адрес: {this.state.email}</li>
            <li className="address">Адрес: {this.state.address}</li>
            <li className="phone">Номер телефона: {this.state.phone}</li>
          </ul>
        </div>
      </div>
    );
  }
}

export default Contacts;
